export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11803.a4dc5490.jpg";